export class ListCloudSnapshotsResponse {
    'snapshotsPerVolume';
    'restorePoints';
    'fsxBackups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotsPerVolume",
            "baseName": "snapshotsPerVolume",
            "type": "Array<CloudSnapshotsPerVolume>",
            "format": ""
        },
        {
            "name": "restorePoints",
            "baseName": "restorePoints",
            "type": "Array<AzureRestorePointData>",
            "format": ""
        },
        {
            "name": "fsxBackups",
            "baseName": "fsxBackups",
            "type": "Array<FsxBackupData>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCloudSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
